export function approvedRecipes(data) {
  return data.filter((item) => {
    return item.status === "approved";
  });
}

export function recommendedRecipes(data) {
  return data.filter((item) => {
    return item.recommended === true;
  });
}

export function categoryRecipes(data, name) {
  if (name === "all") {
    return data;
  } else {
    return data.filter((item) => {
      return item.category === name;
    });
  }
}

export function mealRecipes(data, name) {
  if (name === "all") {
    return data;
  } else {
    return data.filter((item) => {
      return item.meal === name;
    });
  }
}

export function statusRecipes(data, name) {
  return data.filter((item) => {
    return item.status === name;
  });
}

export function getSingleRecipe(data, id) {
  return data.find((item) => item.uuid === id);
}

export function getCategoryFromLocalStorage() {
  return localStorage.getItem("category")
    ? localStorage.getItem("category")
    : "all";
}
